// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"20":"4afe166f","261":"229c18b2","391":"deaa6fee","767":"15d344ea","899":"4afe166f","957":"229c18b2"}[chunkId] + ".css";
};